let jsonData = {};

fetch('https://www.risingsigma.com/zippy-v2/tools/pcchandra.php')
    .then(res => res.json())
    .then(data => {
        jsonData = data;
        handleVariantChange();
    });

const variantInput = document.querySelector('input[name="id"]');

function handleVariantChange() {

    const variantId = variantInput.value;

    const variant = meta.product.variants.find(
        v => String(v.id) === variantId
    );

    if (!variant) return;

    const sku = variant.sku;

    const message =
        jsonData.products?.[sku.split('_')[0]]
            ?.variants?.[sku]
            ?.edd_message;

    // console.log('SKU:', sku);
    // console.log('EDD:', message);

    const titleEl = document.querySelector('.pincode-serviceabilityTitle');

    if (titleEl && message) {
        titleEl.textContent = message;
    }
}

handleVariantChange();

variantInput.addEventListener('change', handleVariantChange);